/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { resetCart } from '../api';

/** Actions */
export const handleFetchError = (
  errors: Array<{
    message: string;
    path: Array<string>;
    extensions: { category: string };
  }>
) => {
  const unauthorized =
    errors.findIndex(
      ({ extensions }) => extensions?.category === 'graphql-authorization'
    ) > -1;

  // Exclude invalid Coupon error
  const missingCart =
    errors.findIndex(
      ({ path, extensions }) =>
        extensions?.category === 'graphql-no-such-entity' &&
        !path?.includes('applyCouponsToCart')
    ) > -1;

  const errorMessage = errors.map((e: any) => e.message).join(' ');

  // Invalid cart
  const invalidCart =
    errors.findIndex(
      ({ path, extensions }) =>
        extensions?.category === 'graphql-input' &&
        path?.includes('cart')
    ) > -1;

  // Reset cart data if unauthorized or missing cart or invalid cart
  if (unauthorized || missingCart || invalidCart) {
    resetCart();
    console.error(errorMessage);
    return null;
  }

  throw Error(errorMessage);
};
